import React from 'react';

const AssignRooms = () => {
  return <div className='assign-rooms main-section'></div>;
};

export default AssignRooms;
